import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useQuery } from 'js/app/hooks/query/useQuery';
import { setRefereeCookie } from 'js/app/utils/referrer.util';
import { setBannerCookie } from 'js/app/utils/affiliate.util';

export const useRefereeCookie = () => {
    const query = useQuery();
    const history = useHistory();

    const removeReferrerFromUrl = () => {
        history.replace({
            search: query.delete('referrer')
        });
    };
    const removeBtagFromUrl = () => {
        history.replace({
            search: query.delete('btag')
        });
    };

    useEffect(() => {
        setBannerCookie(query);
        setRefereeCookie(query, 'btag', removeBtagFromUrl);
        setRefereeCookie(query, 'referrer', removeReferrerFromUrl);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
